// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Complaints Page — Grid Card Layout (Synced with Users) */

.complaints-container {
  padding: 0;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  background: transparent;
  font-family: var(--font-body);
  color: var(--text-primary);
  animation: fadeIn 0.3s ease-out;
}

.complaints-content-surface {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 2rem;
}


/* Grid handled by cards.css */


/* Card base handled by cards.css */

/* Focus */
.complaint-id-btn:focus,
.multiselect-trigger:focus,
.filter-select:focus {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}


/* Loading/Empty handled by general common styles */

/* Generic Filters UI */
.filter-label {
  font-family: var(--font-data);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.filter-select {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 0.875rem;
  transition: border-color 0.15s ease;
  background: var(--bg-primary);
  color: var(--text-primary);
  outline: none;
}
.filter-select:focus { border-color: var(--accent-primary); }

/* Multiselect Wrapper */
.multiselect-wrapper {
  position: relative;
  width: 100%;
}

.multiselect-trigger {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 0.875rem;
  font-family: var(--font-body);
  transition: all 0.2s ease;
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-align: left;
  outline: none;
}

.multiselect-trigger:hover {
  border-color: #cbd5e1;
}

.multiselect-trigger:focus {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.multiselect-trigger-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiselect-arrow {
  flex-shrink: 0;
  color: var(--text-secondary);
  transition: transform 0.2s ease;
}

.multiselect-arrow.open {
  transform: rotate(180deg);
}

.multiselect-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: var(--shadow-md);
  max-height: 250px;
  overflow-y: auto;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.multiselect-checkboxes {
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
}

.multiselect-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s ease;
}

.multiselect-checkbox-label:hover {
  background: var(--nav-hover-bg);
}

.multiselect-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent-primary);
  flex-shrink: 0;
}

.multiselect-checkbox-text {
  font-size: 0.875rem;
  color: var(--text-primary);
  font-weight: 500;
}

.complaints-extra-actions {
  display: flex;
  gap: 20px;
  align-items: center;
}

/* ─── Responsive ─── */
@media (max-width: 768px) {
  .complaints-content-surface {
    padding: 14px;
  }

  .complaints-container .search-main-row {
    gap: 10px;
  }

  .complaints-container .search-input-wrapper,
  .complaints-container .search-actions-unified,
  .complaints-container .search-actions-unified > * {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    flex: 1 1 100%;
  }

  .complaints-extra-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    width: 100%;
  }

  .complaints-container .sort-menu-wrapper,
  .complaints-container .sort-menu-button {
    width: 100%;
  }

  .complaints-container .sort-menu-dropdown {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    min-width: 100% !important;
    transform: none !important;
  }

  .complaints-container .cards-grid {
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 12px;
  }

  .complaints-container .item-card {
    padding: 10px 12px;
  }
}

@media (max-width: 480px) {
  .complaints-content-surface {
    padding: 12px;
    border-radius: 10px;
  }

  .complaints-container .cards-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .complaints-container .orders-pager {
    gap: 8px;
  }

  .complaints-container .orders-pager-controls {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .complaints-container .orders-pager-pages {
    order: 3;
    width: 100%;
    justify-content: center;
  }

  .complaints-container .orders-pager-nav,
  .complaints-container .orders-pager-size {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/complaints.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;;AAGA,8BAA8B;;;AAG9B,mCAAmC;;AAEnC,UAAU;AACV;;;EAGE,wCAAwC;EACxC,mBAAmB;AACrB;;;AAGA,mDAAmD;;AAEnD,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;AACf;AACA,uBAAuB,mCAAmC,EAAE;;AAE5D,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,uBAAuB;EACzB;AACF","sourcesContent":["/* Complaints Page — Grid Card Layout (Synced with Users) */\n\n.complaints-container {\n  padding: 0;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  background: transparent;\n  font-family: var(--font-body);\n  color: var(--text-primary);\n  animation: fadeIn 0.3s ease-out;\n}\n\n.complaints-content-surface {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 2rem;\n}\n\n\n/* Grid handled by cards.css */\n\n\n/* Card base handled by cards.css */\n\n/* Focus */\n.complaint-id-btn:focus,\n.multiselect-trigger:focus,\n.filter-select:focus {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n\n/* Loading/Empty handled by general common styles */\n\n/* Generic Filters UI */\n.filter-label {\n  font-family: var(--font-data);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.filter-select {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 0.875rem;\n  transition: border-color 0.15s ease;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  outline: none;\n}\n.filter-select:focus { border-color: var(--accent-primary); }\n\n/* Multiselect Wrapper */\n.multiselect-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.multiselect-trigger {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 0.875rem;\n  font-family: var(--font-body);\n  transition: all 0.2s ease;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  text-align: left;\n  outline: none;\n}\n\n.multiselect-trigger:hover {\n  border-color: #cbd5e1;\n}\n\n.multiselect-trigger:focus {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.multiselect-trigger-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.multiselect-arrow {\n  flex-shrink: 0;\n  color: var(--text-secondary);\n  transition: transform 0.2s ease;\n}\n\n.multiselect-arrow.open {\n  transform: rotate(180deg);\n}\n\n.multiselect-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  box-shadow: var(--shadow-md);\n  max-height: 250px;\n  overflow-y: auto;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.multiselect-checkboxes {\n  display: flex;\n  flex-direction: column;\n  padding: 6px;\n  gap: 2px;\n}\n\n.multiselect-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 8px;\n  user-select: none;\n  transition: background 0.15s ease;\n}\n\n.multiselect-checkbox-label:hover {\n  background: var(--nav-hover-bg);\n}\n\n.multiselect-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.multiselect-checkbox-text {\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.complaints-extra-actions {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n/* ─── Responsive ─── */\n@media (max-width: 768px) {\n  .complaints-content-surface {\n    padding: 14px;\n  }\n\n  .complaints-container .search-main-row {\n    gap: 10px;\n  }\n\n  .complaints-container .search-input-wrapper,\n  .complaints-container .search-actions-unified,\n  .complaints-container .search-actions-unified > * {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex: 1 1 100%;\n  }\n\n  .complaints-extra-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .complaints-container .sort-menu-wrapper,\n  .complaints-container .sort-menu-button {\n    width: 100%;\n  }\n\n  .complaints-container .sort-menu-dropdown {\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    min-width: 100% !important;\n    transform: none !important;\n  }\n\n  .complaints-container .cards-grid {\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 12px;\n  }\n\n  .complaints-container .item-card {\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .complaints-content-surface {\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .complaints-container .cards-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .complaints-container .orders-pager {\n    gap: 8px;\n  }\n\n  .complaints-container .orders-pager-controls {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .complaints-container .orders-pager-pages {\n    order: 3;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .complaints-container .orders-pager-nav,\n  .complaints-container .orders-pager-size {\n    flex: 1 1 calc(50% - 4px);\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
